
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  Basic JS Helper FUnctions
==============================================================================*/
function urlParams (name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product) {
  // alert('Received everything we ever wanted to know about ' + product.title);
};

Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    $.notify(data.message + '(' + data.status  + '): ' + data.description, {
      className: "error",
      autoHide: false
    });
  } else {
    $.notify('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.', {
      className: "error",
      autoHide: false
    });
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

// GET products/<product-handle>.js returns the product in JSON
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    }
    else {
      Shopify.onProduct(product);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


$(function() {
  
  //Update minicart
  function updateCart(cb) {
    Shopify.getCart(function(cart) {
      $('.template-minicart').html($('#miniCart').tmpl(cart));
      $('#cartCost').html(Shopify.formatMoney(cart.total_price, Venas.money_format));
      $('#cartCount').html(cart.item_count);
      cb();
    })
  };

  //after ajax add
  function show_padd_confirm(product) {
    $.magnificPopup.open({
      items: {
        src: '<div class="white-popup add_confirm"><div class="media">' + $('#addConfirmTemplate').tmpl(product).html() + '</div></div>', // can be a HTML string, jQuery object, or CSS selector
        type: 'inline',
        removalDelay: 300,
        mainClass: 'mfp-fade'
      }
    });
    setTimeout(function() {
      $.magnificPopup.close();
    }, 3000);
  };

  $('body').on('click', 'button.btn-continue-shopping', function() {
    $.magnificPopup.close();
  });

  //Product quick view add to cart button submit click handler
  
  $('body').on('submit', '#frmQuickView', function(e) {
    e.preventDefault(e);
    var pid = $(this).find('#product-select').val(),
        qty = $(this).find('[name="quantity"]').val(),
        $btn =  $(this).find('#add').button('loading');
    Shopify.addItem(pid, qty, function(product) {
      updateCart(function() {
            
        Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val()); 
        
      });
      $btn.button('reset');
      setTimeout(function() {
        $('.modal-open #quick-view-modal').modal('hide');
      }, 200);
      setTimeout(function() {
        show_padd_confirm(product);
      }, 0);
    });
    e.preventDefault(e);
  });
  

  //Product page add to cart button submit click handler
  
  $('#addToCartForm').on('submit', function(e) {
    e.preventDefault(e);
    var pid = $(this).find('#productSelect').val(),
      qty = $(this).find('[name="quantity"]').val(),
      $btn = $('#addToCart').button('loading');
    Shopify.addItem(pid, qty, function(product) {
      
      
      updateCart(function() {
            
        Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val()); 
        
      });
      $btn.button('reset');
      show_padd_confirm(product);
    });
    e.preventDefault(e);
  });
  

  //Product thumb add to cart button click handler
  
  $('body').on('click', '.add-to-cart-thumb', function(e) {
    e.preventDefault(e);
    var pid = $(this).data('default-option');
    var $btn = $(this).button('loading');
    Shopify.addItem(pid, 1, function(product) {
      
      
      updateCart(function() {
            
        Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val()); 
        
      });
      $btn.button('reset');

      show_padd_confirm(product);
    });
    e.preventDefault(e);
  })
  

  //Remove product from minicart
  $('.minicart').on('click', '.remove-product', function(e) {
    e.preventDefault();
    var $this = $(this),
        pid = $this.data('variant-id');
    Shopify.changeItem(pid, 0, function(cart){ 
      $this.closest('.media').addClass('animated fadeOutUp');
      setTimeout(function() {
        $('.template-minicart').html($('#miniCart').tmpl(cart));
        updateCart(function() {
              
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val()); 
          
        });
      }, 500)
    })
  });

  //Open/Close minicart
  
  updateCart(function() {
        
    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val()); 
    
  });
  $('.minicart-wrapper').hover(function() { 
    $('body').find('.minicart').addClass('active');
  }, function() {
    $('body').find('.minicart').removeClass('active');
   
  });
  


});